import backendRuntime_36bddo0ZFkeVd0BE9T_BGebOUjcILWERCoyWP4aa7DSHk from '/app/app/providers/backend-provider.ts'
import ipxRuntime_36r1_YwpCbFBomyWszFN8v5gh78rYe7TCTFYZ35ai1uCY from '/app/node_modules/.pnpm/@nuxt+image@2.1.0_magic-string@1.3.1_magicast@0.5.5_oxc-parser@0.143.0_rolldown@1.2.8_u_bf3e6f2db8ce2de4090428da5a070c7f/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {"thumbnail":{"modifiers":{"format":"webp","width":300,"quality":80}},"banner":{"modifiers":{"format":"webp","width":1200,"quality":80}},"hero":{"modifiers":{"format":"webp","width":1600,"quality":80}},"heroMobile":{"modifiers":{"format":"webp","width":640,"quality":80}},"max":{"modifiers":{"format":"webp","width":1600,"quality":85}},"placeholder":{"modifiers":{"format":"webp","width":100,"quality":20,"fit":"contain","blur":30}},"lazyLoad":{"modifiers":{"format":"webp","width":800,"quality":80,"fit":"contain","background":"transparent","loading":"lazy"}}},
  domains: ["static.northland-co.com"],
  alias: {"/static":"https://static.northland-co.com"},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"ipx"} */
  provider: "ipx",
  providers: {
      ['backend']: { setup: backendRuntime_36bddo0ZFkeVd0BE9T_BGebOUjcILWERCoyWP4aa7DSHk, defaults: {"baseURL":"https://api.northland-co.com/image/optimize"} },
  ['ipx']: { setup: ipxRuntime_36r1_YwpCbFBomyWszFN8v5gh78rYe7TCTFYZ35ai1uCY, defaults: {} }
  }
}
